<template>
  <PopupSizesAsStringContainer v-if="tableData !== ''" @close="closeProductSize" :htmlstring="tableData"/>
</template>

<script lang="ts" setup>

import {onMounted, ref} from "vue";

import PopupSizesAsStringContainer from "@km/components/popups/PopupSizesTableAsStringContainer.vue";
import {loadSizeTable} from "@km/js/loadSizeTable";
import {useStore} from "vuex";


const tableData = ref("");
const store = useStore();

onMounted(() => {
  loadSizeTable(store.getters["ModelStore/getCurrentOwayoProduct"], store.getters["ModelStore/getLanguage"]).then((table) => tableData.value = table);
});

function closeProductSize() {
  store.commit("SET_OVERLAY_CLOSED", 'productsize');
}


</script>

<style lang="scss" scoped>

</style>
